import vuexStore from './store';

export default class Tracking {
  constructor(store) {
    store.getters['tracking/trackingData']
    this.store = store;
  }

  getStoreData (key) {
    return this.store.getters[key];
  }

  getTrackingData () {
    let data = {
      author_id: this.getStoreData('UserMsg').id,
      author_name: this.getStoreData('UserMsg').nickname,
      business: '',
      content_duration: '',
      draft_id: '',
      drafts_number: '',
      is_teamwork: '',
      price_type: '',
      price: '',
      purpose: '',
      source: '',
      teamwork_id: '',
      template_id: '',
      template_name: '',
      template_style: '',
      template_type: '',
      title: '',
      video_duration: '',
    }
  }
}



// WEBPACK FOOTER //
// ./src/tracking.js